<template>
  <BannerLayout
    v-if="items.length"
    :gap="gap"
    :background-color="backgroundColor"
    :background-images="backgroundImages"
    :left-block-size="leftBlockSize"
    :type-left-block="typeLeftBlock"
    :per-page="filtersShown ? 3 : 4"
  >
    <template #header>
      <slot />
    </template>

    <template #default>
      <AkCarousel
        :gap-size="gap"
        :breakpoints="breakpoints"
        :arrows="isAboveOrEqualLg"
        :padding-left="gap"
        :padding-right="gap * 2.5"
        :pagination="false"
        :per-page="perPage"
        :per-move="perMove"
        :class="[`ds-pt-${carouselPadding}`, `ds-py-${carouselPadding}`]"
      >
        <AkCarouselItem
          v-for="(item, index) in items"
          :key="index"
        >
          <slot
            name="item"
            :item="item"
            :index="index"
          />
        </AkCarouselItem>
      </AkCarousel>
      <div
        v-if="$slots.mobileCta && !isAboveOrEqualLg"
        :class="['ds-flex ds-justify-center', 'ds-w-full', 'ds-my-5']"
      >
        <slot name="mobile-cta" />
      </div>
    </template>
  </BannerLayout>
</template>

<script setup lang="ts" generic="TItem">
import { PropType } from 'vue';
import { useBreakpoints } from '@monolith/legacy/modules/design-system-candidates';
import { AkCarousel, AkCarouselItem } from '@ankorstore/design-system';
import BannerLayout from './banner-layout.vue';

defineProps({
  items: {
    type: Array as PropType<TItem[]>,
    required: true,
  },
  breakpoints: {
    type: Object as PropType<{ [key: number]: { [prop: string]: unknown } }>,
    required: false,
    default: () => ({
      1279: { perPage: 2 },
      1023: { perPage: 2 },
      375: { perPage: 1 },
    }),
  },
  carouselPadding: {
    type: Number,
    required: false,
    default: 7,
  },
  gap: {
    type: Number,
    required: false,
    default: 24,
  },
  backgroundColor: {
    type: String,
    default: '#EFF4F5',
  },
  backgroundImages: {
    type: Array as PropType<{ url: string }[]>,
    required: false,
    default: () => [],
  },
  leftBlockSize: {
    type: String as PropType<'column' | 'fixed'>,
    required: false,
    default: 'column',
  },
  perPage: {
    type: Number,
    default: 3,
  },
  perMove: {
    type: Number,
    default: 3,
  },
  typeLeftBlock: {
    type: String as PropType<'recommendations' | 'discovery'>,
    required: false,
    default: 'discovery',
  },
  filtersShown: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { isAboveOrEqualLg } = useBreakpoints();
</script>
